export default __webpack_public_path__ + "static/media/Ella 9781846164644.2cdfd913.jpg";